import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import homeHeaderImage from '../../assets/home-header.png'; 

class HomeHeader extends Component {
  render() {
    return(
      // <Container>
        <Row className="le-home-hero mb-5">
          <Col md={6}>
            <div className="text">
              <h1>Creating beautiful spaces for living</h1>
              <p>
                We're a Interior designer group based in banglore which modifies and create spaces where you can enjoy yourself.
              </p>
              <a href="/contact-us">
                <Button className="le-btn-primary le-btn" size="sm">Get in touch</Button>
              </a>
            </div>
          </Col>
          <Col md={6} className="image">
            <img src={homeHeaderImage} alt="header"/>
          </Col>
        </Row>
      // </Container>
    ) 
  }
}

export default HomeHeader;